export const leftClickEventFilter = (e) =>
   e.button === 0 || e.type === 'tutorial-cancel-user-action';
